import type { ClearBodyPointerEventsLockParams } from '../types';

// Radix Dialog / DropdownMenu can leave body { pointer-events: none } after
// close (DropdownMenu → AlertDialog nesting). Same failure mode as R-032.
const clearBodyPointerEventsLock = ({ reason }: ClearBodyPointerEventsLockParams): boolean => {
    void reason;
    if (document.body.style.pointerEvents !== 'none') {
        return false;
    }
    document.body.style.pointerEvents = '';
    return true;
};

export default clearBodyPointerEventsLock;
